import { useContext } from "react"
import UserContext from "../../services/Context/UserContext"
import Layout from "../Frames/Layout"
import Index from './Activities/Index'

export default function Activities(){

    const {user} = useContext(UserContext)

    return <Layout tab='activities' menu='crm' title='Activités'>

        <Index creator={user} />

    </Layout>
}